export class ApiError extends Error {
  readonly status?: number;
  readonly data?: unknown;
  readonly cause?: unknown;

  constructor(
    message: string,
    status?: number,
    data?: unknown,
    cause?: unknown,
  ) {
    super(message);
    // Required when compiling to ES5 so `instanceof ApiError` works correctly.
    Object.setPrototypeOf(this, ApiError.prototype);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
    this.cause = cause;
  }
}
